import { Box, useColorModeValue } from "@chakra-ui/react";

import Hero from "./components/Common/landing/v2/Hero";
import FeaturesHighlight from "./components/Common/landing/v2/FeaturesHighlight";
import FeatureSections from "./components/Common/landing/v2/FeatureSections";
import SpotifyPodcast from "./components/Common/landing/v1/SpotifyPodcast";
import WorkflowSection from "./components/Common/landing/v2/WorkflowSection";
// import Testimonials from "./components/Common/landing/v2/Testimonials";
import CTASection from "./components/Common/landing/v2/CTASection";

import {
  HOME_PAGE_FEATURES,
  PODCAST_EPISODES,
  WORKFLOW_IMAGE,
} from "./constants/HomePage";
import Footer from "./components/Common/Footer";
import Header from "./components/Common/Header";
import AnimatedSection from "./components/Common/AnimatedSection";
import BackToTopButton from "./components/Common/BackToTopButton";
import { ANIMATION_CONSTANTS } from "./constants/animations";

function LandingPage() {
  const sectionBg = useColorModeValue("gray.50", "gray.900");
  const patternBg = useColorModeValue(
    "url('/assets/patterns/hero-pattern.svg')",
    "url('/assets/patterns/dark-hero-pattern.svg')"
  );

  // Handle navigation for static site
  // const handleNavigation = (
  //   e: React.MouseEvent<HTMLAnchorElement>,
  //   id: string
  // ) => {
  //   e.preventDefault();
  //   const element = document.getElementById(id);
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  return (
    <Box position="relative">
      {/* Header */}
      <Header minimal={false} />

      {/* Hero Section */}
      <AnimatedSection
        id="hero"
        delay={ANIMATION_CONSTANTS.SECTION_DELAYS.HERO}
      >
        <Hero
          heroImage={HOME_PAGE_FEATURES[0]?.image}
          // scrollToSection="features"
        />
      </AnimatedSection>

      {/* Features Highlight */}
      <AnimatedSection
        id="features"
        delay={ANIMATION_CONSTANTS.SECTION_DELAYS.FEATURES}
        staggerDelay={ANIMATION_CONSTANTS.STAGGER.NORMAL}
      >
        <FeaturesHighlight features={HOME_PAGE_FEATURES} />
      </AnimatedSection>

      {/* Feature Sections - Detailed */}
      <AnimatedSection
        id="detailed-features"
        delay={ANIMATION_CONSTANTS.SECTION_DELAYS.DETAILED_FEATURES}
        staggerDelay={ANIMATION_CONSTANTS.STAGGER.SLOW}
      >
        <FeatureSections features={HOME_PAGE_FEATURES} bg={sectionBg} />
      </AnimatedSection>

      {/* Spotify Podcast Section */}
      <AnimatedSection
        id="podcast"
        delay={ANIMATION_CONSTANTS.SECTION_DELAYS.PODCAST}
      >
        <SpotifyPodcast episodes={PODCAST_EPISODES} />
      </AnimatedSection>

      {/* Workflow Section */}
      <AnimatedSection
        id="workflow"
        delay={ANIMATION_CONSTANTS.SECTION_DELAYS.WORKFLOW}
        staggerDelay={ANIMATION_CONSTANTS.STAGGER.SLOWER}
      >
        <WorkflowSection
          workflowImage={WORKFLOW_IMAGE}
          bg={sectionBg}
          patternBg={patternBg}
        />
      </AnimatedSection>

      {/* Testimonials Section */}
      {/* <AnimatedSection
        id="testimonials"
        delay={ANIMATION_CONSTANTS.SECTION_DELAYS.TESTIMONIALS}
        staggerDelay={ANIMATION_CONSTANTS.STAGGER.NORMAL}
      >
        <Testimonials />
      </AnimatedSection> */}

      {/* CTA Section */}
      <AnimatedSection id="cta" delay={ANIMATION_CONSTANTS.SECTION_DELAYS.CTA}>
        <CTASection />
      </AnimatedSection>

      {/* Footer */}
      <AnimatedSection id="footer">
        <Footer />
      </AnimatedSection>

      {/* Back to Top Button */}
      <BackToTopButton />
    </Box>
  );
}

export default LandingPage;
